import script from "./insert-pending.vue?vue&type=script&lang=js"
export * from "./insert-pending.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__